import React, { useEffect, useState } from "react";
import { Select, Spin } from "antd";
import useRequest from "../../hooks/useRequest";
import { ShowToast, Severty } from "../../helper/toast";
import apiPath from "../../constants/apiPath";
const { Option } = Select;

const VehicleSelect = ({ manufacturerId, segmentId, value, onChange, disabled = false, multiple = false }) => {

  const { request } = useRequest();
  const [vehicleList, setVehicleList] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchVehicles = async () => {

    if (!manufacturerId) {
      setVehicleList([]);
      return;
    }

    setLoading(true);
    let url = `${apiPath.commonVehicle}?manufacturer_id=${manufacturerId}`;
    if (segmentId) url += `&segment_id=${segmentId}`;
    request({
      url,
      method: "GET",
      onSuccess: (res) => {
        const vehicles = res?.data?.data || [];
        setVehicleList(vehicles);
        setLoading(false);
      },
      onError: (err) => {
        setLoading(false);
        ShowToast(err?.response?.data?.message || "Failed to load manufacturers", Severty.ERROR);
      },
    });
  }

  useEffect(() => {
    fetchVehicles();
  }, [manufacturerId, segmentId]);

  return (
    <Spin spinning={loading} tip="Loading vehicles..." size="small">
      <Select
        mode={multiple ? "multiple" : undefined}
        maxTagCount={multiple ? "responsive" : undefined}
        showSearch
        allowClear
        placeholder={manufacturerId ? "Select vehicle(s)" : "Select manufacturer first"}
        optionFilterProp="children"
        value={value}
        onChange={(val, option) => onChange?.(val, option)}
        disabled={!manufacturerId || disabled}
        loading={loading}
        filterOption={(input, option) =>
          option?.children?.toLowerCase().includes(input.toLowerCase())
        }
        className="w-full"
        style={multiple ? undefined : { height: 40 }}
      >
        {vehicleList?.map((item) => (
          <Option key={item._id} value={item._id}>
            {item.en_name}
          </Option>
        ))}
      </Select>
    </Spin>
  );
};

export default VehicleSelect;
